import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";

// Sticky WhatsApp click-to-chat button. Opens WhatsApp with pre-filled consult message.
// Positioned bottom-right; lifts above mobile sticky consult bar on small screens.
export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Reveal after slight scroll to avoid competing with hero
    const onScroll = () => setVisible(window.scrollY > 200);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const phone = "16475132225";
  const message = encodeURIComponent(
    "Hi Jean Claude! I'd like to book a free consultation."
  );
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-button"
      className={`fixed z-40 right-4 bottom-24 lg:bottom-6 flex items-center gap-2 rounded-full bg-[#25D366] text-black shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-all duration-500 hover:scale-105 hover:shadow-[0_10px_40px_rgba(37,211,102,0.65)] ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 pointer-events-none translate-y-4"
      }`}
    >
      <span className="grid place-items-center w-14 h-14 rounded-full">
        <MessageCircle size={26} strokeWidth={2.5} fill="currentColor" className="text-black/80" />
      </span>
    </a>
  );
}
